// extracted by mini-css-extract-plugin
export default {"searchform":"doctorsSearchBox_searchform__DKyZl","searchbox":"doctorsSearchBox_searchbox__h7uPQ","searchBtn":"doctorsSearchBox_searchBtn__Hgat9"};